export default {
  "organization": {
    "select_title": "Select your organization",
    "select_description": "Your account has access to multiple organizations. Select which organization you would like to open.",
    "no_org_title": "Organizations not available",
    "no_org_description": "Your account doesn't have access to an organization. Please contact BEEM so we can help set one up for you."
  }
};
